import select2Handler from '../modules/select2Handler';

$ = jQuery;

export default class MapContactPersons {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.form = this.root.querySelector('[data-map-contact-persons-form]');
        this.resultsEl = this.root.querySelector(
            '[data-map-contact-persons-results]'
        );
        this.voidSelectEls = $(this.root).find(
            '[data-map-contact-persons-voidvoideship]'
        );
        this.leaderEl = this.root.querySelector(
            '[data-map-contact-persons-leader]'
        );
        this.voidSelectInstances = null;

        this.regionEls = this.root.querySelectorAll('[data-region]');
        this.svgMap = this.root.querySelector('[data-svg-map]');

        return true;
    }

    init() {
        this.initSelect();
        this.initRegions();
    }

    initRegions() {
        if (!this.regionEls || !this.voidSelectInstances) return;

        this.regionEls.forEach(item => {
            item.addEventListener('click', e => {
                const { currentTarget } = e;
                const region = currentTarget.getAttribute('data-region');
                const option = this.root.querySelector(
                    `[data-map-name="${region}"]`
                );

                if (option) {
                    const voidId = option.value;
                    if (voidId) {
                        this.resetRegions();
                        item.classList.add('active');

                        this.voidSelectInstances[0]
                            .val(voidId)
                            .trigger('change');
                        this.loadPersons();
                    }
                }
            });
        });
    }

    initSelect() {
        if (!this.voidSelectEls) return;
        const instance = this;

        this.voidSelectInstances = select2Handler(this.voidSelectEls);
        this.voidSelectEls.each(function () {
            const select = $(this);

            select.on('select2:select', function (e) {
                instance.resetRegions();

                const { target } = e;
                const { value } = target;
                const option = target.querySelector(`[value="${value}"]`);

                if (option) {
                    const mapName = option.getAttribute('data-map-name');

                    instance.regionEls.forEach(item => {
                        const regName = item.getAttribute('data-region');
                        if (regName === mapName) item.classList.add('active');
                        if (mapName === 'all') item.classList.add('active');
                    });

                    if (mapName === 'none') {
                        instance.svgMap.style.display = 'none';
                    } else {
                        instance.svgMap.style.display = 'block';
                    }
                }

                instance.loadPersons();
            });
        });
    }

    resetRegions() {
        if (!this.regionEls) return;
        this.regionEls.forEach(item => item.classList.remove('active'));
    }

    loadPersons() {
        const formData = new FormData(this.form);

        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { html, leader_html, contact_persons } = data;

                this.resultsEl.innerHTML = html;
                this.leaderEl.innerHTML = leader_html;

                if (contact_persons.length === 1) {
                    this.resultsEl.classList.add('single-grid');
                } else {
                    this.resultsEl.classList.remove('single-grid');
                }
            }.bind(this),
            error: function () {}.bind(this),
            complete: function () {}.bind(this),
        });
    }
}
